<p-toast position="bottom-center"></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

    <app-page-hero
        [eyebrow]="t('pages.companyDeliveries.hero.eyebrow')"
        [title]="t('pages.companyDeliveries.hero.title')"
        [subtitle]="t('pages.companyDeliveries.hero.subtitle')">
        <div actions>
            <p-button [label]="t('pages.companyDeliveries.hero.refresh', 'Refresh')" icon="pi pi-refresh" [outlined]="true" (onClick)="refresh()"></p-button>
            <p-button [label]="t('pages.companyDeliveries.hero.exportExcel', 'Export Excel')" icon="pi pi-file-excel" severity="secondary" [outlined]="true"
                [loading]="isExporting" [pTooltip]="t('pages.companyDeliveries.hero.exportTooltip', 'Requires a scheduled date range of one month or less; exports up to 100 rows.')"
                (onClick)="exportExcel()"></p-button>
            <p-button *ngIf="permissionService.hasPermission(app_permissions.shipments.view)"
                [label]="t('pages.companyDeliveries.hero.shipmentDirectory', 'Shipment Directory')" icon="pi pi-list" severity="secondary" [outlined]="true"
                (onClick)="openShipmentDirectory()"></p-button>
            <p-button *ngIf="permissionService.hasPermission(app_permissions.shipments.CREATE)"
                [label]="t('pages.companyDeliveries.hero.newShipment', 'New Shipment')" icon="pi pi-plus" (onClick)="createShipment()"></p-button>
        </div>
    </app-page-hero>

    <app-page-search-panel
        [title]="t('pages.companyDeliveries.search.title')"
        [activeFilters]="activeFilterCount()"
        [resultText]="resultText()"
        [collapsed]="true"
        (search)="applyFilters()"
        (clear)="clearFilters()">
        <div class="formgrid grid shipment-form-grid">
            <div class="col-12 directory-filter-heading"><i class="pi pi-hashtag"></i> {{ t('pages.companyDeliveries.search.references', 'References') }}</div>
            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="shipmentNumber" type="text" [(ngModel)]="filterModel.shipmentNumber" [placeholder]="t('pages.companyDeliveries.search.shipmentNumberPlaceholder')">
                        <label for="shipmentNumber">{{ t('pages.companyDeliveries.search.shipmentNumber') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>

            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="waybillNumber" type="text" [(ngModel)]="filterModel.waybillNumber" [placeholder]="t('pages.companyDeliveries.search.waybillNumberPlaceholder')">
                        <label for="waybillNumber">{{ t('pages.companyDeliveries.search.waybillNumber') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>

            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="deliveryNumber" type="text" [(ngModel)]="filterModel.deliveryNumber" [placeholder]="t('pages.companyDeliveries.search.deliveryNumberPlaceholder')">
                        <label for="deliveryNumber">{{ t('pages.companyDeliveries.search.deliveryNumber') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>

            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="searchTerm" type="text" [(ngModel)]="filterModel.searchTerm" [placeholder]="t('pages.companyDeliveries.search.searchPlaceholder')">
                        <label for="searchTerm">{{ t('pages.companyDeliveries.search.search') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-link"></i></p-inputGroupAddon><p-iftaLabel>
                    <input pInputText id="deliveryReleaseNumber" [(ngModel)]="filterModel.releaseNumber" placeholder="ORL/…">
                    <label for="deliveryReleaseNumber">{{ t('pages.companyDeliveries.search.releaseNumber', 'Order Release Number') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-bookmark"></i></p-inputGroupAddon><p-iftaLabel>
                    <input pInputText id="deliveryReferenceText" [(ngModel)]="filterModel.referenceText" placeholder="External or customer order reference">
                    <label for="deliveryReferenceText">{{ t('pages.companyDeliveries.search.referenceText', 'External / Customer Reference') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="col-12 directory-filter-heading"><i class="pi pi-users"></i> {{ t('pages.companyDeliveries.search.clientsProjects', 'Clients & Projects') }}</div>
            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect inputId="clients" [options]="clientOptions" [(ngModel)]="filterModel.clients" [placeholder]="t('pages.companyDeliveries.search.selectClients')" display="chip" [showClear]="true" [filter]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('clients')" (onFilter)="filterOptions('clients', $event.filter)" (onLazyLoad)="loadNextOptions('clients', $event)" styleClass="w-full"></p-multiSelect>
                        <label for="clients">{{ t('pages.companyDeliveries.search.legacyCustomers', 'Legacy Customers') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>

            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="legacyCompanies" [options]="legacyCompanyOptions" [(ngModel)]="filterModel.legacyCompanies" display="chip" [filter]="true" [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('legacyCompanies')" (onFilter)="filterOptions('legacyCompanies', $event.filter)" (onLazyLoad)="loadNextOptions('legacyCompanies', $event)" styleClass="w-full"></p-multiSelect>
                    <label for="legacyCompanies">{{ t('pages.companyDeliveries.search.legacyCompanies', 'Legacy Companies') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="deliveryCrmClients" [options]="crmClientOptions" [(ngModel)]="filterModel.crmClients" display="chip" [filter]="true" [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('crmClients')" (onFilter)="filterOptions('crmClients', $event.filter)" (onLazyLoad)="loadNextOptions('crmClients', $event)" styleClass="w-full"></p-multiSelect>
                    <label for="deliveryCrmClients">{{ t('pages.companyDeliveries.search.crmClients', 'CRM Clients') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="deliveryCrmAccounts" [options]="crmAccountOptions" [(ngModel)]="filterModel.crmAccounts" display="chip" [filter]="true" [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('crmAccounts')" (onFilter)="filterOptions('crmAccounts', $event.filter)" (onLazyLoad)="loadNextOptions('crmAccounts', $event)" styleClass="w-full"></p-multiSelect>
                    <label for="deliveryCrmAccounts">{{ t('pages.companyDeliveries.search.crmAccounts', 'CRM Accounts') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-address-book"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="deliveryCrmContacts" [options]="crmContactOptions" [(ngModel)]="filterModel.crmContacts" display="chip" [filter]="true" [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('crmContacts')" (onFilter)="filterOptions('crmContacts', $event.filter)" (onLazyLoad)="loadNextOptions('crmContacts', $event)" styleClass="w-full"></p-multiSelect>
                    <label for="deliveryCrmContacts">{{ t('pages.companyDeliveries.search.crmContacts', 'CRM Contacts') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-select inputId="deliveryProject" [options]="logisticsProjectOptions" [(ngModel)]="filterModel.logisticsProjectId" [filter]="true" [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('projects')" (onFilter)="filterOptions('projects', $event.filter)" (onLazyLoad)="loadNextOptions('projects', $event)" appendTo="body" styleClass="w-full"></p-select>
                    <label for="deliveryProject">{{ t('pages.companyDeliveries.search.logisticsProject') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="col-12 directory-filter-heading"><i class="pi pi-map"></i> {{ t('pages.companyDeliveries.search.routeSchedule', 'Route & Schedule') }}</div>

            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect inputId="source" [options]="sourceLocationOptions" [(ngModel)]="filterModel.sourceLocations" [placeholder]="t('pages.companyDeliveries.search.sourceLocations')" display="chip" [showClear]="true" [filter]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('sourceLocations')" (onFilter)="filterOptions('sourceLocations', $event.filter)" (onLazyLoad)="loadNextOptions('sourceLocations', $event)" styleClass="w-full"></p-multiSelect>
                        <label for="source">{{ t('pages.companyDeliveries.search.sourceLocation') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>

            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect inputId="destination" [options]="destinationLocationOptions" [(ngModel)]="filterModel.destinationLocations" [placeholder]="t('pages.companyDeliveries.search.destinationLocations')" display="chip" [showClear]="true" [filter]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('destinationLocations')" (onFilter)="filterOptions('destinationLocations', $event.filter)" (onLazyLoad)="loadNextOptions('destinationLocations', $event)" styleClass="w-full"></p-multiSelect>
                        <label for="destination">{{ t('pages.companyDeliveries.search.destinationLocation') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>

            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon><p-iftaLabel>
                    <input pInputText id="deliveryPickupCity" [(ngModel)]="filterModel.pickupCity" placeholder="Pickup city">
                    <label for="deliveryPickupCity">{{ t('pages.companyDeliveries.search.pickupCity', 'Pickup City') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon><p-iftaLabel>
                    <input pInputText id="deliveryDropoffCity" [(ngModel)]="filterModel.dropoffCity" placeholder="Drop-off city">
                    <label for="deliveryDropoffCity">{{ t('pages.companyDeliveries.search.dropoffCity', 'Drop-off City') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-datePicker inputId="dateRange" [(ngModel)]="filterModel.dateRange" selectionMode="range" [readonlyInput]="true" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                    <label for="dateRange">{{ t('pages.companyDeliveries.search.scheduledDate') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar-plus"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-datePicker inputId="deliveryCreatedRange" [(ngModel)]="filterModel.createdDateRange" selectionMode="range" [readonlyInput]="true" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                    <label for="deliveryCreatedRange">{{ t('pages.companyDeliveries.search.createdDateRange', 'Shipment Created Date') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="col-12 directory-filter-heading"><i class="pi pi-sliders-h"></i> {{ t('pages.companyDeliveries.search.operations', 'Operations') }}</div>

            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect inputId="vehicle" [options]="vehicleOptions" [(ngModel)]="filterModel.vehicles" [placeholder]="t('pages.companyDeliveries.search.vehicles')" display="chip" [showClear]="true" [filter]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('vehicles')" (onFilter)="filterOptions('vehicles', $event.filter)" (onLazyLoad)="loadNextOptions('vehicles', $event)" styleClass="w-full"></p-multiSelect>
                        <label for="vehicle">{{ t('pages.companyDeliveries.search.vehicle') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>

            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect inputId="driver" [options]="driverOptions" [(ngModel)]="filterModel.drivers" [placeholder]="t('pages.companyDeliveries.search.drivers')" display="chip" [showClear]="true" [filter]="true" [virtualScroll]="true" [virtualScrollItemSize]="36" [lazy]="true" (onShow)="openOptions('drivers')" (onFilter)="filterOptions('drivers', $event.filter)" (onLazyLoad)="loadNextOptions('drivers', $event)" styleClass="w-full"></p-multiSelect>
                        <label for="driver">{{ t('pages.companyDeliveries.search.driver') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>

            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-info-circle"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect inputId="deliveryStatuses" [options]="deliveryStatusOptions"
                            [(ngModel)]="filterModel.statuses" optionLabel="label" optionValue="value"
                            [placeholder]="t('pages.companyDeliveries.search.selectDeliveryStatuses')" display="chip" [showClear]="true"
                            appendTo="body" styleClass="w-full"></p-multiSelect>
                        <label for="deliveryStatuses">{{ t('pages.companyDeliveries.search.deliveryStatus') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-user-plus"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-select inputId="assignmentState" [options]="assignmentOptions"
                            [(ngModel)]="filterModel.assignmentState" optionLabel="label" optionValue="value"
                            [placeholder]="t('pages.companyDeliveries.search.allAssignments')" [showClear]="true" appendTo="body"
                            styleClass="w-full"></p-select>
                        <label for="assignmentState">{{ t('pages.companyDeliveries.search.assignmentReadiness') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
        </div>
    </app-page-search-panel>
    <div class="directory-active-filters" *ngIf="appliedChips.length">
        <button type="button" class="directory-filter-chip" *ngFor="let chip of appliedChips" (click)="removeFilter(chip.key)" [attr.aria-label]="'Remove ' + chip.label">
            {{ chip.label }} <i class="pi pi-times"></i>
        </button>
    </div>

    <app-page-metric-strip [metrics]="deliveryMetrics()"></app-page-metric-strip>

    <app-page-data-panel
        [title]="t('pages.companyDeliveries.dataPanel.title')"
        [subtitle]="t('pages.companyDeliveries.dataPanel.subtitle')"
        [resultText]="resultText()">
        <p-table [value]="deliveries" dataKey="deliveryId" [resizableColumns]="true" [rowHover]="true" [loading]="isLoading"
            styleClass="p-datatable-sm p-datatable-gridlines delivery-rich-table"
            [tableStyle]="{ 'min-width': '105rem' }" [paginator]="true" [rows]="pageSize" [first]="first"
            [rowsPerPageOptions]="[10, 25, 50]" [showCurrentPageReport]="true"
            [currentPageReportTemplate]="currentPageReportTemplate()"
            [totalRecords]="totalDeliveries" [lazy]="true" (onLazyLoad)="loadDeliveries($event)" [sortField]="sortField" [sortOrder]="sortOrder">
            <ng-template pTemplate="header">
                <tr>
                    <th class="delivery-action-col">{{ t('pages.companyDeliveries.table.actions', 'Actions') }}</th>
                    <th pSortableColumn="deliveryId" style="width: 18rem">
                        {{ t('pages.companyDeliveries.table.deliveryContext', 'Delivery & Context') }} <p-sortIcon field="deliveryId"></p-sortIcon>
                    </th>
                    <th pSortableColumn="shipmentNumber" style="width: 24rem">
                        {{ t('pages.companyDeliveries.table.shipmentPartyContext', 'Shipment & Party Context') }} <p-sortIcon field="shipmentNumber"></p-sortIcon>
                    </th>
                    <th style="width: 27rem">{{ t('pages.companyDeliveries.table.route', 'Route') }}</th>
                    <th pSortableColumn="scheduledTime" style="width: 25rem">
                        {{ t('pages.companyDeliveries.table.assignmentSchedule', 'Assignment & Schedule') }} <p-sortIcon field="scheduledTime"></p-sortIcon>
                    </th>
                    <th pSortableColumn="jobStatus" style="width: 23rem">
                        {{ t('pages.companyDeliveries.table.progressStatus', 'Progress & Latest Status') }} <p-sortIcon field="jobStatus"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td class="delivery-action-col">
                        <div class="delivery-row-actions">
                            <p-button icon="pi pi-truck" [rounded]="true" [text]="true" severity="info"
                                [pTooltip]="t('pages.companyDeliveries.table.viewDelivery', 'View delivery')" tooltipPosition="right"
                                (onClick)="viewDelivery(row)"></p-button>
                            <p-button *ngIf="permissionService.hasPermission(app_permissions.shipments.view)"
                                icon="pi pi-eye" [rounded]="true" [text]="true" severity="success"
                                [pTooltip]="t('pages.companyDeliveries.table.viewShipment', 'Open shipment operations view')" tooltipPosition="right"
                                (onClick)="viewShipment(row)"></p-button>
                            <p-button *ngIf="permissionService.hasPermission(app_permissions.shipments.view)"
                                icon="pi pi-th-large" [rounded]="true" [text]="true" severity="secondary"
                                [pTooltip]="t('pages.companyDeliveries.table.advancedWorkspace', 'Open advanced shipment workspace')" tooltipPosition="right"
                                (onClick)="viewShipment(row, true)"></p-button>
                        </div>
                    </td>
                    <td>
                        <div class="delivery-rich-stack">
                            <button type="button" class="shipment-link-button" (click)="viewDelivery(row)">
                                {{ row.deliveryNumber || '-' }}
                            </button>
                            <span class="delivery-cell-meta">ID {{ row.deliveryId }}</span>
                            <div class="delivery-tag-row">
                                <p-tag
                                    [value]="formatStatusLabel(deliveryLifecycleStatus(row))"
                                    [severity]="getStatusSeverity(deliveryLifecycleStatus(row))"></p-tag>
                                <p-tag *ngIf="row.deliveryType"
                                    [value]="formatStatusLabel(row.deliveryType)" severity="secondary"></p-tag>
                                @for (waybillNumber of waybillNumbers(row); track waybillNumber) {
                                    <p-tag [value]="t('pages.companyDeliveries.table.waybillPrefix') + waybillNumber" severity="success"></p-tag>
                                }
                            </div>
                            <span><i class="pi pi-link"></i>{{ linkedReference(row) }}</span>
                            <span *ngIf="row.customerOrderNumber">
                                <i class="pi pi-shopping-cart"></i>Order {{ row.customerOrderNumber }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="delivery-rich-stack">
                            <button type="button" class="shipment-link-button" (click)="viewShipment(row)">
                                {{ row.shipmentNumber || '-' }}
                            </button>
                            <span class="delivery-cell-meta">CRM client</span>
                            <p-chip *ngIf="row.crmClient?.name || row.customer?.name"
                                [label]="row.crmClient?.name || row.customer?.name || '-'"
                                [image]="row.crmClient?.imageUrl || row.customer?.imageUrl"></p-chip>
                            <span *ngIf="!row.crmClient?.name && !row.customer?.name">-</span>
                            <span *ngIf="row.crmAccount?.name" class="delivery-cell-meta">
                                <i class="pi pi-building"></i> CRM account: {{ row.crmAccount?.name }}
                            </span>
                            <span *ngIf="row.crmClient?.name && !row.crmAccount?.name && row.customer?.name"
                                class="delivery-cell-meta">
                                <i class="pi pi-sitemap"></i> Sub-party: {{ row.customer?.name }}
                            </span>
                            <span *ngIf="row.crmClientContact?.name" class="delivery-cell-meta">
                                <i class="pi pi-user"></i> CRM contact: {{ row.crmClientContact?.name }}
                            </span>
                            <span *ngIf="row.createdBy?.name" class="delivery-cell-meta">
                                <i class="pi pi-user-plus"></i> Created by {{ row.createdBy?.name }}
                            </span>
                            <span *ngIf="row.updatedBy?.name" class="delivery-cell-meta">
                                <i class="pi pi-user-edit"></i> Updated by {{ row.updatedBy?.name }}
                            </span>
                            <span *ngIf="row.shipmentExternalReference">
                                <i class="pi pi-hashtag"></i>{{ row.shipmentExternalReference }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="delivery-route-flow">
                            <div class="delivery-route-point source">
                                <span class="route-marker"><i class="pi pi-map-marker"></i></span>
                                <div>
                                    <span class="delivery-cell-meta">{{ t('pages.companyDeliveries.table.pickup') }}</span>
                                    <strong>{{ row.sourceLocation?.name || '-' }}</strong>
                                    <small>{{ row.sourceLocation?.address || t('pages.companyDeliveries.table.addressPending') }}</small>
                                </div>
                            </div>
                            <div class="delivery-route-line"></div>
                            <div class="delivery-route-point destination">
                                <span class="route-marker"><i class="pi pi-flag"></i></span>
                                <div>
                                    <span class="delivery-cell-meta">{{ t('pages.companyDeliveries.table.dropoff') }}</span>
                                    <strong>{{ row.destinationLocation?.name || '-' }}</strong>
                                    <small>{{ row.destinationLocation?.address || t('pages.companyDeliveries.table.addressPending') }}</small>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="delivery-assignment-grid">
                            <div class="assignment-resource" [class.needs-assignment]="!row.driver?.label">
                                <i class="pi pi-user"></i>
                                <div>
                                    <span>{{ t('pages.companyDeliveries.table.driver') }}</span>
                                    <strong>{{ row.driver?.label || t('pages.companyDeliveries.table.needsAssignment') }}</strong>
                                    <small>{{ row.driver?.ownershipType || t('pages.companyDeliveries.table.ownershipPending') }} · {{ row.driver?.owner || '-' }}</small>
                                </div>
                            </div>
                            <div class="assignment-resource" [class.needs-assignment]="!row.vehicle?.label">
                                <i class="pi pi-truck"></i>
                                <div>
                                    <span>{{ t('pages.companyDeliveries.table.vehicle') }}</span>
                                    <strong>{{ row.vehicle?.label || t('pages.companyDeliveries.table.needsAssignment') }}</strong>
                                    <small>{{ row.vehicle?.ownershipType || t('pages.companyDeliveries.table.ownershipPending') }} · {{ row.vehicle?.owner || '-' }}</small>
                                </div>
                            </div>
                            <span class="assignment-meta" *ngIf="row.driver?.agency || row.driver?.sourceCompany || row.vehicle?.agency || row.vehicle?.sourceCompany">
                                <i class="pi pi-building"></i>
                                {{ row.driver?.agency || row.vehicle?.agency || row.driver?.sourceCompany || row.vehicle?.sourceCompany }}
                            </span>
                            <span class="assignment-meta"><i class="pi pi-calendar-clock"></i>
                                {{ formatDateTime(row.scheduledTime) || t('pages.companyDeliveries.table.schedulePending') }}
                            </span>
                            <span class="assignment-meta"><i class="pi pi-bookmark"></i>
                                {{ formatStatusLabel(row.bookingOption || t('pages.companyDeliveries.table.bookingPending')) }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="delivery-rich-stack">
                            <div class="delivery-progress-header">
                                <span>{{ t('pages.companyDeliveries.table.deliveryProgress') }}</span>
                                <strong>{{ deliveryProgress(row) }}%</strong>
                            </div>
                            <p-progressBar [value]="deliveryProgress(row)" [showValue]="false"
                                styleClass="delivery-directory-progress"></p-progressBar>
                            <span class="delivery-cell-meta">{{ deliveryProgressCaption(row) }}</span>
                            <span class="delivery-cell-meta" *ngIf="row.operation?.activeStop">Active: {{ row.operation?.activeStop }}</span>
                            <span class="delivery-cell-meta" *ngIf="row.operation?.nextStop">Next: {{ row.operation?.nextStop }}</span>
                            <span><i class="pi pi-box"></i>{{ payloadSummary(row) }}</span>
                            <span><i class="pi pi-clock"></i>Updated:
                                {{ latestOperationalUpdate(row) ? formatDateTime(latestOperationalUpdate(row)) : '-' }}
                            </span>
                            <div class="delivery-tag-row">
                                <p-tag [value]="(row.fileCount || 0) + ' ' + t('pages.companyDeliveries.table.deliveryFiles', { count: '' }).trim()"
                                    severity="secondary"></p-tag>
                                <p-tag *ngIf="row.driver?.label && row.vehicle?.label" [value]="t('pages.companyDeliveries.table.fullyAssigned')" severity="success"></p-tag>
                                <p-tag *ngIf="!row.driver?.label || !row.vehicle?.label" [value]="t('pages.companyDeliveries.table.confirmationPending')" severity="warn"></p-tag>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">
                        <div class="shipment-empty-state">
                            <i class="pi pi-search"></i>
                            <strong>{{ t('pages.companyDeliveries.empty.title') }}</strong>
                            <span>{{ t('pages.companyDeliveries.empty.subtitle') }}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
